module.exports = __webpack_public_path__ + "img/e_2_14_g.789e9809.png";